export default __webpack_public_path__ + "static/media/banner-1.ba0056a7.jpg";